import { onValue, set } from "firebase/database";
import {
    FETCH_ADD_ON,
    FETCH_ADD_ON_SUCCESS,
    FETCH_ADD_ON_FAILED,
    UPDATE_ADD_ON,
} from "../../store/types";
import { firebase } from "../../config/configureFirebase";
import store from "../../store/store";

export const fetchAddOn = () => (dispatch) => {
    try {
        console.log("🚀 fetchAddOn: Starting addon fetch");
        const { addOnRef } = firebase;

        if (!addOnRef) {
            console.error("❌ Firebase addOnRef is not properly initialized");
            dispatch({
                type: FETCH_ADD_ON_FAILED,
                payload: "Firebase reference not initialized",
            });
            return;
        }

        console.log("📤 fetchAddOn: Dispatching FETCH_ADD_ON");
        dispatch({
            type: FETCH_ADD_ON,
            payload: null,
        });

        console.log("👂 fetchAddOn: Setting up onValue listener");
        onValue(
            addOnRef,
            (snapshot) => {
                console.log("📥 fetchAddOn: Received snapshot");
                const data = snapshot.val();
                console.log("📊 fetchAddOn: Snapshot data:", data);

                if (data) {
                    console.log(
                        "✅ fetchAddOn: Data found, dispatching success"
                    );
                    dispatch({
                        type: FETCH_ADD_ON_SUCCESS,
                        payload: data,
                    });
                } else {
                    console.log("❌ fetchAddOn: No data found");
                    dispatch({
                        type: FETCH_ADD_ON_FAILED,
                        payload:
                            "Unable to fetch database and add-on settings.",
                    });
                }
            },
            (error) => {
                console.error("❌ Firebase onValue error:", error);
                dispatch({
                    type: FETCH_ADD_ON_FAILED,
                    payload: error.message,
                });
            }
        );
    } catch (error) {
        console.error("❌ fetchAddOn error:", error);
        dispatch({
            type: FETCH_ADD_ON_FAILED,
            payload: error.message,
        });
    }
};

export const updateAddOn = (data, onFailure, onSuccess) => (dispatch) => {
    const { addOnRef } = firebase;

    if (!addOnRef) {
        if (onFailure) {
            onFailure();
        }

        return;
    }

    dispatch({
        type: UPDATE_ADD_ON,
        payload: data,
    });

    set(addOnRef, data);
    if (onSuccess) {
        onSuccess();
    }
};
